// extracted by mini-css-extract-plugin
export default {"checkbox":"style_checkbox__UFl0q","label":"style_label__7Je-O","input":"style_input__uHXqp"};